import React from "react";

const ErrorPage = () => {
    return (
        <div>
            <h1>
                There was an error 
            </h1>
        </div>
    )
}

export default ErrorPage;